import { TextField } from "@mui/material";
import { FC } from "react";

type StartAndEndDateFiltersProps = {
  startDate: string,
  setStartDate: (dt: string) => void,
  endDate: string,
  setEndDate: (dt: string) => void,
}

const StartAndEndDateFilters: FC<StartAndEndDateFiltersProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}): JSX.Element => {
  return (
    <>
      <TextField
        label="Data inicial"
        type="date"
        value={startDate}
        onChange={(e) => {
          setStartDate(e.target.value);
        }}
      />
      <TextField
        label="Data final"
        type="date"
        value={endDate}
        onChange={(e) => {
          setEndDate(e.target.value);
        }}
      />
    </>
  )
}

export default StartAndEndDateFilters;
